import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UperIcon } from "../../GlobalIcons";

import "./style.css";
import { useCookies } from "react-cookie";
import { scrollToTop } from "../../../utils/func";

const CookieMsg = () => {
  const [cookies, setCookie] = useCookies(["trp"]);
  const [confirmCookie, setConfirmCookie] = useState(false);
  const [scrollButtonVisible, setScrollButtonVisible] = useState(false);

 

  const handleSetCookie = () => {
    setCookie("confirm", "CookieConfirm", { maxAge: 31536000 });
    setConfirmCookie(true);
  };

  useEffect(() => {
    if (cookies.confirm) {
      setConfirmCookie(true);
    }
  }, [cookies.confirm]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setScrollButtonVisible(true);
      } else {
        setScrollButtonVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={`footer_end_sec ${confirmCookie === false && "fixed"}`}>
      {confirmCookie === false && (
        <>
          <p>
            This website uses cookies to ensure you get the best experience on
            our website.<Link>Learn more</Link>
          </p>
          <div className="got_it_sec">
            <button onClick={handleSetCookie}>Got it!</button>
          </div>
        </>
      )}

      {confirmCookie === true && <p>© All Rights Reserved by trpworld</p>}

      {scrollButtonVisible && (
        <button className="scrollToTop" onClick={scrollToTop}>
          <UperIcon />
        </button>
      )}
    </div>
  );
};

export default CookieMsg;
